export const FULL_SCREEN_CLASS = 'full-screen';
